import ReactDOM from 'react-dom/client'
import App from './app'
import { createMsalInstance } from './auth-config'

createMsalInstance().then((msalInstance) => {
  ReactDOM.createRoot(document.getElementById('root')!).render(<App msalInstance={msalInstance} />)
})
